var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRollup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.26 18.565H3.74C2.36 18.565 1.25 17.445 1.25 16.075V10.225C1.25 9.94499 1.47 9.72499 1.75 9.72499C2.03 9.72499 2.25 9.94499 2.25 10.225V16.075C2.25 16.895 2.92 17.565 3.74 17.565H16.25C17.07 17.565 17.74 16.895 17.74 16.075V10.225C17.74 9.94499 17.96 9.72499 18.24 9.72499C18.52 9.72499 18.74 9.94499 18.74 10.225V16.075C18.74 17.455 17.62 18.565 16.25 18.565H16.26Z",
    fill: "#20CB0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.04 2.435H1.96C1.69 2.435 1.46 2.215 1.46 1.935C1.46 1.655 1.68 1.435 1.96 1.435H18.04C18.32 1.435 18.54 1.655 18.54 1.935C18.54 2.215 18.32 2.435 18.04 2.435Z",
    fill: "#20CB0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.04 5.11499H1.96C1.68 5.11499 1.46 4.89499 1.46 4.61499C1.46 4.33499 1.68 4.11499 1.96 4.11499H18.04C18.32 4.11499 18.54 4.33499 18.54 4.61499C18.54 4.89499 18.32 5.11499 18.04 5.11499Z",
    fill: "#20CB0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.04 7.785H1.96C1.68 7.785 1.46 7.565 1.46 7.285C1.46 7.005 1.68 6.785 1.96 6.785H18.04C18.32 6.785 18.54 7.005 18.54 7.285C18.54 7.565 18.32 7.785 18.04 7.785Z",
    fill: "#20CB0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.13 15.345C14.03 15.345 13.93 15.315 13.84 15.255L12.2 14.105C11.97 13.945 11.92 13.635 12.08 13.405C12.24 13.175 12.55 13.125 12.78 13.285L14.13 14.235L15.48 13.285C15.71 13.125 16.02 13.185 16.18 13.405C16.34 13.635 16.28 13.945 16.06 14.105L14.42 15.255C14.33 15.315 14.23 15.345 14.13 15.345Z",
    fill: "#20CB0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.77 11.875C15.67 11.875 15.57 11.845 15.48 11.785L14.13 10.835L12.78 11.785C12.55 11.945 12.24 11.885 12.08 11.665C11.92 11.435 11.98 11.125 12.2 10.965L13.84 9.81499C14.01 9.69499 14.24 9.69499 14.41 9.81499L16.05 10.965C16.28 11.125 16.33 11.435 16.17 11.665C16.07 11.805 15.92 11.875 15.76 11.875H15.77Z",
    fill: "#20CB0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.13,
    fill: "white",
    transform: "translate(1.25 1.435)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollup);
export default __webpack_public_path__ + "static/media/rollup.41e23c94273d6dab492ee167450e2f5e.svg";
export { ForwardRef as ReactComponent };